import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  private paginationStates = new Map<string, { pageIndex: BehaviorSubject<number>, numberOfRows: BehaviorSubject<number> }>();

  initializeTable(tableId: string, initialRows: number = 10) {
    if (!this.paginationStates.has(tableId)) {
      this.paginationStates.set(tableId, {
        pageIndex: new BehaviorSubject<number>(0),
        numberOfRows: new BehaviorSubject<number>(initialRows)
      });
    }
  }

  setPageIndex(tableId: string, index: number) {
    this.paginationStates.get(tableId)?.pageIndex.next(index);
  }

  setNumberOfRowsInPage(tableId: string, rows: number) {
    this.paginationStates.get(tableId)?.numberOfRows.next(rows);
  }

  getPageIndex$(tableId: string): Observable<number> {
    const state = this.paginationStates.get(tableId);
    return state ? state.pageIndex.asObservable() : throwError(() => new Error(`Table with ID ${tableId} not initialized`));
  }

  getNumberOfRowsInPage$(tableId: string): Observable<number> {
    const state = this.paginationStates.get(tableId);
    return state ? state.numberOfRows.asObservable() : throwError(() => new Error(`Table with ID ${tableId} not initialized`));
  }
}
